<div>
  <ng-container *ngIf="!timeOnly">
    <label *ngIf="dateLabel">{{dateLabel}}</label>
    <br *ngIf="dateLabel">
    <p-calendar
      [(ngModel)]="dateValue"
      (ngModelChange)="onDateChange($event)"
      (onBlur)="markTouched()"
      [placeholder]="datePlaceholder"
      appendTo="body"
      class="full-width"
      dataType="string"
      [dateFormat]="dateFormat"
      [minDate]="minDate"
      [showOnFocus]="false"
      [disabled]="disabled"
      [class.ng-invalid]="dateInvalid"
      [class.ng-dirty]="dateInvalid"
      showIcon="true"
      ></p-calendar>
  </ng-container>

  <div [class.p-mt-2]="!timeOnly">
    <label *ngIf="timeLabel">{{timeLabel}}</label>
    <br *ngIf="timeLabel">
    <p-autoComplete
      [(ngModel)]="timeValue"
      (ngModelChange)="onTimeChange($event)"
      (onBlur)="onTimeBlur()"
      [placeholder]="timePlaceholder"
      appendTo="body"
      styleClass="full-width"
      inputStyleClass="full-width"
      [ariaLabel]="timeLabel || 'Time'"
      [suggestions]="timeSuggestions"
      (completeMethod)="searchTime($event)"
      [dropdown]="true"
      [showEmptyMessage]="false"
      [disabled]="disabled"
      [class.ng-invalid]="timeInvalid"
      [class.ng-dirty]="timeInvalid"
      ></p-autoComplete>
  </div>
</div>
